/**
 * Format a distance in metres for the Nearby-variant trailing label.
 *
 * - `< 1000 m` → metres rounded to the nearest 10 (`"220 m"`).
 * - `>= 1000 m` → kilometres with one decimal (`"1.2 km"`).
 *
 * Matches the Figma "Nearby" row distance labels (220 m / 650 m / 1.2 km).
 */
export function formatDistance(meters: number): string {
  if (meters >= 1000) {
    return `${(meters / 1000).toFixed(1)} km`
  }
  return `${Math.round(meters / 10) * 10} m`
}
